import actions, { ActionConstants } from './actions';
import reducer from './reducers';
export * from './selectors';

export const currentUserReducer = reducer;
export const CurrentUserActionConstants = ActionConstants;
export const CurrentUserActions = actions;
export default actions;



// WEBPACK FOOTER //
// ./src/redux-modules/current-user/index.js